import React from 'react';
import { Alert, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useOrgPhoneNumbers } from 'hooks/useOrgPhoneNumbers';
import { getValidOrgId } from 'utils/storageUtils';
import { useTranslation } from 'react-i18next';
import { SHELL_NS } from 'recruiter-i18n/namespaces/shell';

/**
 * App-wide warning shown to every user of an org that has no dedicated phone
 * number registered. Calls still go out via shared fallback numbers, but a
 * dedicated number is better for deliverability and caller-ID trust, so we
 * prompt the org to contact support. Renders nothing until we've confirmed
 * (fetch succeeded) that the org truly has zero numbers.
 */
export const NoPhoneNumbersBanner: React.FC = () => {
  const { t } = useTranslation(SHELL_NS);
  const orgId = getValidOrgId();
  const { hasNoPhoneNumbers } = useOrgPhoneNumbers(orgId);

  if (!hasNoPhoneNumbers) {
    return null;
  }

  return (
    <Alert
      icon={<IconAlertCircle size={24} />}
      title={t('phoneBanner.title')}
      color='orange'
      m='sm'
      styles={{
        root: { backgroundColor: '#fff3cd' },
      }}
    >
      <Text size='sm'>{t('phoneBanner.message')}</Text>
    </Alert>
  );
};
